import {
	GoogleMap,
	LoadScript,
	MarkerF,
	PolylineF,
} from "@react-google-maps/api";
import { useEffect } from "react";
import { useState } from "react";
import { FaMapMarked, FaRegClipboard } from "react-icons/fa";
import RoundedButton from "../../components/btn-rounded";
import MenuNavigator from "../../components/menu-navigator";
import handleProfilePic from "../../utils/functions/profilePic";
import Tecnicos from "../Tecnicos";
import "./styles.css";
import Requests from "../../services/requests";
import { FiArrowLeft, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { BiRefresh } from "react-icons/bi";

const Mapa = ({ token }) => {
	const [positions, setPositions] = useState([]);
	const [locations, setLocations] = useState([]);
	const [locationsPage, setLocationPage] = useState([]);
	const [page, setPage] = useState(0);
	const [popup, setPopup] = useState();
	const [selectedTec, setSelectedTec] = useState();
	let limit = Math.round(window.screen.height / 45);

	useEffect(() => {
		if (selectedTec) {
			setLocations([]);
			let config = { headers: { "x-access-token": token } };
			Requests.getLocalizacao(selectedTec, config).then((res) => {
				if (res) {
					setLocations(res);
					//lógica que gerencia as páginas do dgrid
					let startContent = [];
					for (let i = limit * page; i < limit * page + limit; i++) {
						if (res[i]) {
							startContent.push(res[i]);
						}
					}
					//setta os states com o resultado da request
					setLocations(res);
					setLocationPage(startContent);
					setPage(0);
				} else {
					setLocations([]);
					setLocationPage([]);
					setPage(0);
				}
			});
		}
	}, [selectedTec]);

	const handleChangePage = (l = locations, page) => {
		let actualRotas = [];
		for (let i = limit * page; i < limit * page + limit; i++) {
			if (l[i]) {
				actualRotas.push(l[i]);
			}
		}
		setLocationPage(actualRotas);
	};

	const handlePageAble = (button) => {
		switch (button) {
			case "left":
				if (page === 0) {
					return false;
				} else {
					return true;
				}
			case "right":
				if (page < locations.length / limit - 1) {
					return true;
				} else {
					return false;
				}

			default:
				break;
		}
	};

	const detalhesPopUp = (detalhes) => {
		return (
			<div className="popup">
				<div>
					<p
						className="voltar"
						onClick={() => {
							setPopup();
						}}
					>
						<FiArrowLeft size={20} />
						Voltar
					</p>
					<h1 className="txt-title">Detalhes</h1>
					<p>
						{detalhes.length === 0 && (
							<div className="refresh-page">
								<BiRefresh />
							</div>
						)}
						{!Array.isArray(detalhes) &&
							detalhes.nomes.map((detalhe, i) => {
								return (
									<li className="list" key={"detalhe" + i}>
										{detalhe}
									</li>
								);
							})}
						{!Array.isArray(detalhes) && detalhes.nomes.length === 0 && (
							<div className="txt-aviso-popup">
								Não há checklists ou rotas feitas.
							</div>
						)}
					</p>
				</div>
			</div>
		);
	};

	const options = {
		strokeColor: "#FF4400",
		strokeOpacity: 0.8,
		strokeWeight: 4,
		fillColor: "#FF4400",
		fillOpacity: 0.35,
		clickable: false,
		draggable: false,
		editable: false,
		visible: true,
		radius: 30000,
		paths: positions,
		zIndex: 1,
	};

	const handleViewComponent = () => {
		return (
			<div className="main">
				<div id="bloco-1">
					<div className="header">
						<div id="bloco-header-1">
							{selectedTec && selectedTec.id ? (
								<fieldset>
									<legend>Mapa do Técnico</legend>
									<div id="tecnico">
										<div className="agenda-profile-div">
											<div id="pic">
												<p>{handleProfilePic(selectedTec)}</p>
											</div>
											<div id="nome">
												<p className="nome">
													{selectedTec.nome ? selectedTec.nome : "nome"}
												</p>
												<p className="tipo">
													{selectedTec.tipo ? selectedTec.tipo : "tipo"}
												</p>
											</div>
										</div>
										<div
											id="select"
											onClick={() => {
												setPopup(
													<Tecnicos
														setSelectedTec={setSelectedTec}
														token={token}
														setPopup={setPopup}
													/>
												);
											}}
										>
											<RoundedButton
												type={"link"}
												event={"/mapa"}
												text={"Alterar técnico"}
											></RoundedButton>
										</div>
									</div>
								</fieldset>
							) : (
								<fieldset>
									<legend>Mapa do Técnico</legend>
									<div id="tecnico">
										<div>
											<div id="nome">
												<p>Nenhum técnico selecionado</p>
											</div>
										</div>
										<div
											id="select"
											onClick={() => {
												setPopup(
													<Tecnicos
														setSelectedTec={setSelectedTec}
														token={token}
														setPopup={setPopup}
													/>
												);
											}}
										>
											<RoundedButton
												type={"link"}
												event={"/mapa"}
												text={"Escolher técnico"}
											></RoundedButton>
										</div>
									</div>
								</fieldset>
							)}
						</div>
					</div>
					{positions.length > 0 && (
						<div className="mapa">
							<LoadScript
								googleMapsApiKey={"AIzaSyCEHbVsEWIdHvMkOd_09BvAE9csjUYBHj0"}
							>
								<GoogleMap
									mapContainerStyle={{ width: "100%", height: "100%" }}
									center={positions[0]}
									zoom={18}
									options={{
										maxZoom: 30,
										minZoom: 14,
										mapTypeId: "satellite",
										streetViewControl: false,
									}}
									key={JSON.stringify(positions)}
								>
									<PolylineF
										onLoad={polyline => {
											console.log('polyline: ', polyline)
										}}
										path={positions}
										options={options}
									/>
									{positions.map((position, i) => {
										let t = JSON.stringify(position);
										if (i === 0) {
											return (
												<MarkerF
													key={t}
													position={position}
													icon={{
														url: "https://static.vecteezy.com/system/resources/previews/009/267/136/non_2x/location-icon-design-free-png.png",
														scaledSize: { height: 14, width: 10 },
													}}
												/>
											);
										}

										if (i === positions.length - 1) {
											return (
												<MarkerF
													key={t}
													position={position}
													icon={{
														url: "https://static.vecteezy.com/system/resources/previews/010/160/458/non_2x/pin-location-icon-sign-symbol-design-free-png.png",
														scaledSize: { height: 14, width: 10 },
													}}
												/>
											);
										}
										return (
											<MarkerF
												key={t}
												position={position}
												icon={{
													url: "https://images.emojiterra.com/google/android-10/512px/1f535.png",
													scaledSize: { height: 4, width: 4 },
												}}
											/>
										);
									})}
								</GoogleMap>
							</LoadScript>
						</div>
					)}
				</div>
				<div id="bloco-2">
					<div>
						<table>
							<tr>
								<th>Nº Inspeção</th>
								<th>Hora</th>
								<th>Data</th>
								<th>Deslocamento</th>
								<th>Detalhes</th>
							</tr>
							{selectedTec &&
								locationsPage.map((location) => (
									<tr>
										<td>{location.id}</td>
										<td>
											{(+location.data_inspecao.substring(11,13) - 3).toString().padStart(2, "0") + location.data_inspecao.substring(13,19)}
										</td>
										<td>
											{location.data_inspecao.substring(8, 10)}/
											{location.data_inspecao.substring(5, 7)}/
											{location.data_inspecao.substring(0, 4)} 
										</td>
										<td>
											<div
												className="icon-visualizar"
												onClick={() => {
													let config = { headers: { "x-access-token": token } };
													Requests.getJsons(location, config).then((res) => {
														setPositions(
															res.map((r) => {
																return { lat: r.latitude || r.lt, lng: r.longitude || r.lg };
															})
														);
													});
												}}
											>
												<FaMapMarked style={{ color: "white" }} />
											</div>
										</td>
										<td>
											<div
												className="icon-visualizar"
												onClick={() => {
													let config = { headers: { "x-access-token": token } };
													Requests.getDetalhes(location, config).then((res) => {
														setPopup(detalhesPopUp(res));
													});
													setPopup(detalhesPopUp([]));
												}}
											>
												<FaRegClipboard style={{ color: "white" }} />
											</div>
										</td>
									</tr>
								))}
						</table>
						{!selectedTec && <div>Selecione um técnico</div>}
						{selectedTec && locations.length === 0 && (
							<div>Não há registros de deslocamento</div>
						)}
						{selectedTec && locations.length > 0 && (
							<div className="txt-page">
								<span>
									{limit * page +
										1 +
										"-" +
										(limit * page + limit < locations.length
											? limit * page + limit
											: locations.length) +
										" de " +
										locations.length}
								</span>
								{handlePageAble("left") ? (
									<FiChevronLeft
										className="enable"
										onClick={() => {
											setTimeout(() => {
												setPage(page - 1);
												handleChangePage(locations, page - 1);
											}, 200);
										}}
									/>
								) : (
									<FiChevronLeft className="disable" />
								)}
								{handlePageAble("right") ? (
									<FiChevronRight
										className="enable"
										onClick={() => {
											setTimeout(() => {
												setPage(page + 1);
												handleChangePage(locations, page + 1);
											}, 200);
										}}
									/>
								) : (
									<FiChevronRight className="disable" />
								)}
							</div>
						)}
					</div>
				</div>
				{popup && (
					<div id="bg-popup" style={{ zIndex: 10000 }}>
						{popup}
					</div>
				)}
			</div>
		);
	};

	return (
		<div>
			<MenuNavigator page="/mapa" view={handleViewComponent()} />
		</div>
	);
};

export default Mapa;
